import { render, staticRenderFns } from "./ConfigTableClassicLinkedIn.vue?vue&type=template&id=9774198a&"
import script from "./ConfigTableClassicLinkedIn.vue?vue&type=script&lang=js&"
export * from "./ConfigTableClassicLinkedIn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports